module.exports = __webpack_public_path__ + "static/media/iconStatisticsActive.a80f2774.svg";